import { useTranslation } from 'react-i18next';
import PaginaTexto from '../Compartido/PaginaTexto.jsx';

const TextoPropiedads = ({ propiedades, ruta }) => {

    const { t } = useTranslation();

    return (
        <PaginaTexto
            titulo={t("Propiedades")}
            eyebrow={t("Empresa")}
            imagen={propiedades.imagen_cabecera ? ruta + "/" + propiedades.imagen_cabecera : null}
            html={propiedades.ladesc}
        />
    );
}

export default TextoPropiedads;
